import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class NativeShareService {
    constructor() {}

    shareUrl(url: string, title?: string, text?: string) {
        const data = {
            title: title,
            url: url,
        };

        if (navigator.canShare(data)) {
            return navigator.share(data);
        } // In case navigator api is not available we can do something else
        return false;
    }
}
